<div class="photos-list-container">
    <div class="search-bar">
        <input class="coloring" type="text" [(ngModel)]="prompt" placeholder="Search for photos..." />
        <button
            mat-button
            mat-raised-button
            class="search-button"
            color="primary"
            [disabled]="!(prompt && prompt.length > 0)"
            (click)="setNewPrompt(prompt)">
            Search
            <mat-icon>search</mat-icon>
        </button>

        <div class="row-centered gapped tags">
            <ng-container *ngFor="let tag of this.tagsForPrompt">
                <mat-chip class="tag" (click)="setNewPrompt(tag.text)">
                    <span>{{ tag.text }}</span>
                </mat-chip>
            </ng-container>
        </div>
    </div>

    <div class="photos-grid">
        <div
            *ngFor="let photo of photos || []"
            class="photo-item clickable"
            [ngClass]="{ selected: photo === selectedPhoto, disabled: isLoading }"
            (click)="selectPhoto(photo)">
            <!-- IMAGE -->
            <ng-container *ngIf="photo.type === 'image'">
                <div
                    class="photo-background photo-item clickable"
                    [style.background-image]="'url(' + photo.urls.small + ')'"></div>
            </ng-container>

            <!-- VIDEO -->
            <ng-container *ngIf="photo.type === 'video'">
                <video
                    #videoPlayer
                    class="asset-video photo-item clickable"
                    [src]="photo.urls.full"
                    autoplay
                    loop
                    playsinline
                    (loadedmetadata)="onLoadedMetadata(videoPlayer)"></video>
            </ng-container>

            <!-- Spinner -->
            <div class="spinner-holder" *ngIf="photo === selectedPhoto">
                <loading-indicator></loading-indicator>
            </div>

            <!-- Hover Text -->
            <div *ngIf="!selectedPhoto" class="photo-hover-text">{{ this.texts.selectText }}</div>

            <!-- Photographer Info -->
            <ng-container *ngIf="photo.duration as duration">
                <span class="duration"> {{ duration }} sec </span>
            </ng-container>
            <ng-container *ngIf="photo.photographer as photographer">
                <span
                    class="photographer"
                    *ngIf="photographer.linkToProfile as linkToProfile"
                    (click)="goToProfile(linkToProfile); $event.stopPropagation()">
                    {{ this.texts.assetByText }} by {{ photographer.name ?? 'Name' }}
                </span>
            </ng-container>
        </div>
    </div>
</div>

<div class="no-images row-centered">
    <div *ngIf="photos?.length === 0" class="no-images">
        <p>{{ this.texts.noAssetsText }}</p>
    </div>
</div>
<div *ngIf="this.source" class="powered-by gapped row-centered">
    <span>Powered by</span>
    <a [href]="this.source.linkTo" target="_blank" rel="noopener noreferrer">
        <img *ngIf="source.imageSrc" [src]="source.imageSrc" />
    </a>
</div>
<!-- Pagination Controls -->
<div class="pagination" *ngIf="photos.length > this.itemsPerPage - 1">
    <button
        mat-flat-button
        class="cool-button gray navigation"
        (click)="goToPage(currentPage - 1)"
        [disabled]="currentPage === 1">
        <mat-icon>navigate_before</mat-icon>
        Previous
    </button>

    <ng-container *ngFor="let page of totalPages; let i = index">
        <button
            mat-mini-fab
            class="cool-button gray page"
            (click)="goToPage(i + 1)"
            [class.active]="i + 1 === currentPage">
            {{ i + 1 }}
        </button>
    </ng-container>

    <button
        mat-flat-button
        class="cool-button gray navigation"
        (click)="goToPage(currentPage + 1)"
        [disabled]="currentPage === totalPages.length">
        Next
        <mat-icon iconPositionEnd>navigate_next</mat-icon>
    </button>
</div>

<ng-template #loading>
    <p>{{ this.texts.loadingAssetText }}</p>
</ng-template>
